<script lang="jsx">
import { mapGetters } from 'vuex';
import Config from './config.vue';
import BuyTrial from './buy-trial.vue';

export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['boughtPlans','getSelectedPlans']),
  },
  render() {
    const context = { ...this.$attrs, configPlanTileStatus: this.configPlanTileStatus };
    // Free trial: add2trial / buyTrial
    if (this.$context.is.buyTrial || this.$context.is.add2trial) {
      return <BuyTrial {...context} />;
    }
    // Paid flow: add2cart, trial2paid (free trial to paid)
    if (this.$context.is.add2cart || this.$context.is.trial2paid) {
      return <Config {...context} />;
    }
    return null;
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
</style>
